import axios from "axios";
import moment from "moment";

export default {
    async getOrders(context) {
        let params = await context.dispatch('prepareParams', context.state.ordersConfig, { root: true })

        let dateFrom = moment(context.state.date_from).format('YYYY-MM-DD')
        let dateTo = moment(context.state.date_to).format('YYYY-MM-DD')

        params[`filter[date_between]`] = `${dateFrom},${dateTo}`

        return new Promise((resolve, reject) => {
            axios.get('/administration/commandes/api', {
                params
            }).then((response) => {
                context.commit('setOrders', response.data.orders)
                resolve(response);
            }).catch((error) => {
                reject(error);
            })
        });
    },

    async export(context) {
        let params = await context.dispatch('prepareParams', context.state.ordersConfig, { root: true })

        let dateFrom = moment(context.state.date_from).format('YYYY-MM-DD')
        let dateTo = moment(context.state.date_to).format('YYYY-MM-DD')

        params[`filter[date_between]`] = `${dateFrom},${dateTo}`

        return new Promise((resolve, reject) => {

              
              const url = '/administration/commandes/api/export';
              const res = axios.getUri({url, params});

              resolve(res);


            
        });
    },
};
